var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilledIdentity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 13C26.3125 13 27 13.6875 27 14.5V27.5C27 28.3438 26.3125 29 25.5 29H16.5C15.6562 29 15 28.3438 15 27.5V14.5C15 13.6875 15.6562 13 16.5 13H25.5ZM21 18C19.875 18 19 18.9062 19 20C19 21.125 19.875 22 21 22C22.0938 22 23 21.125 23 20C23 18.9062 22.0938 18 21 18ZM24 26C24.25 26 24.5 25.7812 24.5 25.5C24.5 24.125 23.375 23 22 23H20C18.5938 23 17.5 24.125 17.5 25.5C17.5 25.7812 17.7188 26 18 26H24ZM22.5 16C22.75 16 23 15.7812 23 15.5C23 15.25 22.75 15 22.5 15H19.5C19.2188 15 19 15.25 19 15.5C19 15.7812 19.2188 16 19.5 16H22.5Z",
    fill: "#5F6774"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledIdentity);
export default __webpack_public_path__ + "static/media/filledIdentity.f2245a7ff8729b6e21d7ad95e632bded.svg";
export { ForwardRef as ReactComponent };